module.exports = __webpack_public_path__ + "img/image.208cb581.svg";